import styled from '@emotion/styled';
import { tokens, Text } from '@hotjar/hotsauce';

export const ObserveContextualBar = {
  TrafficBarTitleWrapper: styled('div')`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    max-width: 55%;
  `,
  Text: styled(Text)`
    margin-bottom: ${tokens.spacer.x1};
  `,
};
